import PropTypes from 'prop-types';
import CategorySelect from '../../Select/CategorySelect';
import Budget from './Budget/Budget';
import DailyCaps from './DailyCaps/DailyCaps';
import Naming from './Naming/Naming';
import Timing from './Timing/Timing';
import { useTranslation } from 'react-i18next';

function WizardBasics({
    isActive,
    isResizeMapOn,
    currencyDefault,
    selectedScreens,
    service,
    totalSpent,
    dispatch,
    currencies,
    budgets,
    isTest,
    validator,
    basics,
    updateBasics,
}) {
    const { name, brand, budget, selectedCreativeCategories, timing } = basics;
    const { t } = useTranslation();
    return (
        <>
            {!isActive ? (
                ''
            ) : (
                <div
                    className={`basics mt-2 h-full overflow-visible overflow-y-auto text-sm transition-transform duration-300 ${
                        isResizeMapOn
                            ? 'transform scale-75 -translate-y-20'
                            : ''
                    }`}>
                    <div className="text-xs text-gray-500 ml-4 pt-4 -mb-1 font-semibold">
                        * {t('sections.campaigns.new-campaign.required-fields')}
                    </div>
                    <Naming
                        name={name}
                        brand={brand}
                        dispatch={dispatch}
                        isTest={isTest}
                        validator={validator}
                        onNameChange={(value) => updateBasics('name', value)}
                        onBrandChange={(value) => updateBasics('brand', value)}
                    />
                    <CategorySelect
                        selectedCreativeCategories={selectedCreativeCategories}
                        dispatch={dispatch}
                        service={service}
                        validator={validator}
                        onChange={(value) =>
                            updateBasics('selectedCreativeCategories', value)
                        }
                    />
                    <Budget
                        budget={budget}
                        budgets={budgets}
                        validator={validator}
                        totalSpent={totalSpent}
                        currencies={currencies}
                        selectedScreens={selectedScreens}
                        selectedCurrency={basics.selectedCurrency}
                        currencyDefault={currencyDefault}
                        updateBasics={updateBasics}
                    />
                    <Timing
                        service={service}
                        timing={timing}
                        totalSpent={totalSpent}
                        dispatch={dispatch}
                        validator={validator}
                        onTimingChange={(value) =>
                            updateBasics('timing', value)
                        }
                    />
                    <DailyCaps
                        dailyCaps={basics.dailyCaps}
                        timing={timing}
                        budget={budget}
                        totalSpent={totalSpent}
                        selectedCurrency={basics.selectedCurrency}
                        updateBasics={updateBasics}
                    />
                </div>
            )}
        </>
    );
}

WizardBasics.proptyTypes = {
    isActive: PropTypes.bool.isRequired,
    name: PropTypes.string,
    brand: PropTypes.string,
    isResizeMapOn: PropTypes.bool,
    selectedCurrency: PropTypes.object,
    currencies: PropTypes.object,
    budget: PropTypes.object,
    campaign: PropTypes.object,
    dailyCap: PropTypes.object,
    service: PropTypes.func,
    timing: PropTypes.object,
    totalSpent: PropTypes.number,
    dispatch: PropTypes.func,
    selectedCreativeCategories: PropTypes.array,
};

export default WizardBasics;
